var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { accountExportTemplateEntityName, } from '../../../../../backend/features/accounts/shared';
import { useContactManagementTranslation, useUserState } from '../../../../../ui/hooks';
import { showWizardDialog } from '@juvare/common-form-ui/showWizardDialog';
import { showCustomDialog, showErrorDialog } from '@juvare/common-web-ui/DialogHelper';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { getSettings } from '@juvare/platform-sdk-react/ui/features/editable-settings';
import { useStorageClient, useStorageList } from '@juvare/platform-sdk-react/ui/hooks';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { Box, Button, CircularProgress, Grid, Radio, Stack, Typography } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { useAccountExportWizardSteps } from '../../hooks/useAccountExportWizardSteps';
import { AccountExportTemplateTable } from './AccountExportTemplateTable';
import { ExportTemplateCard } from './ExportTemplateCard';
export const ExportAccountDialog = ({ onCustomExport, onCancel, onEditTemplate, onExport, submitLabel, initialTab, }) => {
    const [templateId, setTemplateId] = React.useState(undefined);
    const { t } = useContactManagementTranslation();
    const userState = useUserState();
    const settings = useSelector(getSettings);
    const storageClient = useStorageClient(accountExportTemplateEntityName);
    const { selectFieldsStep, columnOrderStep } = useAccountExportWizardSteps();
    const [tab, setTab] = React.useState(initialTab !== null && initialTab !== void 0 ? initialTab : 'default');
    const { data: exportTemplates, isLoading } = useStorageList(accountExportTemplateEntityName, {
        filter: [
            {
                column: 'accountId',
                op: '=',
                value: userState.id,
            },
        ],
    });
    if (isLoading)
        return React.createElement(CircularProgress, null);
    const handleCustomExportSubmit = (_a) => __awaiter(void 0, [_a], void 0, function* ({ sortedFields, name }) {
        try {
            if (name) {
                const { id } = yield storageClient.post({
                    action: 'create',
                    data: {
                        name,
                        accountId: userState.id,
                        fields: sortedFields,
                    },
                });
                onExport({ templateId: id });
                return;
            }
            onExport({ fields: sortedFields });
        }
        catch (error) {
            handleErrorSnackbar(error);
        }
    });
    const handleCustomExport = () => {
        onCustomExport();
        showWizardDialog({
            onSubmit: handleCustomExportSubmit,
            steps: [selectFieldsStep(), columnOrderStep()],
            title: t('export.customExport'),
            submitButtonLabel: t('export.export'),
            maxWidth: 'xl',
        });
    };
    const handleTabChange = (e) => {
        const value = e.currentTarget.value;
        if (value === 'default' || value === 'saved') {
            setTab(value);
        }
        setTemplateId(undefined);
    };
    const handleExport = () => {
        if (templateId) {
            onExport({ templateId });
        }
        else if (tab === 'default') {
            onExport();
        }
        else {
            showErrorDialog({ title: t('export.templateIsRequired') });
        }
    };
    const defaultItems = settings.accountExport
        .filter((field) => field.default)
        .map(({ headerName }, index) => ({
        id: `${headerName}-${index}`,
        label: headerName,
    }));
    return (React.createElement(Stack, { p: 3, gap: 2 },
        React.createElement(Typography, { variant: 'h6' }, t('export.exportAccount')),
        !!(exportTemplates === null || exportTemplates === void 0 ? void 0 : exportTemplates.rows.length) && (React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { size: {
                    xs: 12,
                    sm: 6,
                } },
                React.createElement(Stack, { direction: 'row', alignItems: 'center', p: 2, bgcolor: themeColors.surface.secondary, borderRadius: 1 },
                    React.createElement(Radio, { onChange: handleTabChange, checked: tab === 'default', value: 'default' }),
                    React.createElement(Typography, { variant: 'subtitle2' }, t('export.types.default')))),
            React.createElement(Grid, { size: {
                    xs: 12,
                    sm: 6,
                } },
                React.createElement(Stack, { direction: 'row', alignItems: 'center', p: 2, bgcolor: themeColors.surface.secondary, borderRadius: 1 },
                    React.createElement(Radio, { onChange: handleTabChange, checked: tab === 'saved', value: 'saved' }),
                    React.createElement(Typography, { variant: 'subtitle2' }, t('export.types.template')))))),
        tab === 'default' && (React.createElement(Box, { borderRadius: 1, p: 2, bgcolor: themeColors.surface.secondary },
            React.createElement(ExportTemplateCard, { csvPreviewItems: defaultItems, actions: [
                    React.createElement(Button, { key: 'custom-export', onClick: handleCustomExport, startIcon: React.createElement(EditOutlinedIcon, null) }, t('export.customExport')),
                ], name: t('export.standard') }))),
        tab === 'saved' && (React.createElement(Box, { borderRadius: 1, p: 2, bgcolor: themeColors.surface.secondary },
            React.createElement(AccountExportTemplateTable, { onEditTemplate: onEditTemplate, onTemplateChange: setTemplateId, onAfterEditTemplate: () => {
                    showCustomDialog({
                        content: (close) => (React.createElement(ExportAccountDialog, { onExport: onExport, onCustomExport: () => close(undefined), onCancel: () => close(undefined), onEditTemplate: () => close(undefined), submitLabel: t('export.export'), initialTab: 'saved' })),
                        maxWidth: 'xl',
                        onEscapeKeyDown: (close) => close(),
                    });
                } }))),
        React.createElement(Stack, { gap: 2, direction: 'row', justifyContent: 'end' },
            React.createElement(Button, { onClick: onCancel }, t('common.cancel')),
            React.createElement(Button, { onClick: handleExport }, submitLabel !== null && submitLabel !== void 0 ? submitLabel : t('export.export')))));
};
